import { isNonEmpty } from '@ais-ui/utils';
import React from 'react';

interface EventGridItemProps {
  label: string | null | undefined;
  value: string | null | undefined;
}

export const EventGridItem = ({ label, value }: EventGridItemProps) => {
  return (
    <div className="flex flex-col gap-1">
      <p className="text-sm font-medium flex-none">{label}</p>
      <p className="text-sm text-muted-foreground flex-grow text-ellipsis overflow-hidden">
        {isNonEmpty(value) ? value : 'Unknown'}
      </p>
    </div>
  );
};
